<template>
  <v-container>
  <v-layout row wrap justify-center>
    <v-flex sm8 xs12>
      {{this.message}}
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import TwitchWrapper from '@/TwitchWrapper'

export default {
  name: 'auth',
  data () {
    return {
      message: 'Loading',
      response: '',
      isLoaded: false,

      twitch: new TwitchWrapper(this.$root.$data.clientId),
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      console.log(document.location.hash)
      let result = document.location.hash.split('&').reduce(function (result, item) {
          var parts = item.split('=');
          result[parts[0]] = parts[1];
          return result;
      }, {});

      if(result['#access_token']){
        let token = result['#access_token']

        this.$root.$data.token = token
        this.$root.$data.isLoggedIn = true
        localStorage.token = token

        let state = result.state
        let redirectArr = state.split('_')

        this.message = 'Login Succeeded'

        this.$router.push(decodeURIComponent(redirectArr[0]))
      }
      else {
        this.message = 'Failed to login'
      }
    },
  }
}
</script>